module.exports = __webpack_public_path__ + "static/img/yz3.b4c35e3f.png";